import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    color: ${cssTheme.colors.blue.dark};
    cursor: pointer;
    inline-size: auto;
    user-select: none;
  `,
  opened: css`
    transform: rotate(-90deg);
  `,
  icon: css`
    font-size: 1.23rem;
    transition: transform 0.2s ease-out;
  `,
  title: css`
    color: ${cssTheme.colors.blue.dark};
    display: block;
    max-inline-size: ${spacing(20)}; // 160px
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
}
